import React from 'react';
import { Footer } from '../components/layout/Footer';

/**
 * Section - Footer Section
 * About cards + footer
 */
export function FooterSection({ backgroundColor }) {
  return (
    <div
      id="kontakt"
      className="min-h-screen flex flex-col w-full relative"
      style={{
        scrollSnapAlign: 'start',
        scrollSnapStop: 'always',
      }}
    >
      {/* Content area */}
      <div className="flex-1 flex items-center justify-center px-4 sm:px-8 md:px-16 lg:px-24 pb-4">
        <div className="max-w-6xl w-full">
          {/* Section Heading */}
          <div className="text-right mb-10">
            <p className="text-gray-400 text-sm uppercase tracking-widest mb-2">Das Team hinter schmalgsicht</p>
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white">
              Über uns
            </h2>
          </div>

          {/* About Cards - Asymmetric Overlap */}
          <div className="relative md:pb-16 mb-2">
            {/* schmalsoft solutions - Large left block */}
            <div className="md:w-2/3 mb-6 md:mb-0">
              <div className="bg-white rounded-2xl p-6">
                <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-3">Über schmalsoft solutions</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed md:pr-48 lg:pr-56">
                  <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500">schmalsoft solutions</span> ist ein innovatives Tech-Unternehmen, das die Zukunft des Radios gestaltet.
                  Mit modernster <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500">KI-Technologie</span> entwickeln wir personalisierte Audio-Erlebnisse, die sich perfekt an die
                  Bedürfnisse und Stimmungen unserer Hörer anpassen.
                </p>
              </div>
            </div>

            {/* schmalgsicht - Floating right block */}
            <div className="md:absolute md:right-0 md:top-1/2 md:-translate-y-1/2 md:w-1/2">
              <div className="bg-gradient-to-br from-pink-500 to-purple-600 rounded-2xl p-6">
                <h3 className="text-lg sm:text-2xl font-bold text-white mb-3">schmalgsicht – Unser Flaggschiff</h3>
                <p className="text-white/90 text-sm sm:text-base leading-relaxed">
                  <span className="font-semibold">schmalgsicht</span> ist das Top-Produkt des schmalsoft Konzerns. Was als experimentelles Projekt begann,
                  ist heute eine Revolution in der Art und Weise, wie Menschen Radio erleben. Mit <span className="font-semibold">schmalgsicht v2</span> setzen
                  wir neue Maßstäbe in der personalisierten Audio-Unterhaltung.
                </p>
              </div>
            </div>
          </div>

          {/* Vision - full width */}
          <div className="bg-blue-500 rounded-2xl p-6">
            <h3 className="text-lg sm:text-2xl font-bold text-white mb-3">Unsere Vision</h3>
            <p className="text-white/90 text-sm sm:text-base leading-relaxed">
              Wir glauben an ein Radio, das <span className="font-semibold">nicht nur sendet, sondern zuhört</span>. Ein Radio, das versteht, was du brauchst,
              bevor du es selbst weißt. Mit <span className="font-semibold">schmalgsicht v2</span> schaffen wir eine Brücke zwischen menschlicher Emotion und
              künstlicher Intelligenz – für ein Hörerlebnis, <span className="font-semibold">das so einzigartig ist wie du</span>.
            </p>
          </div>
        </div>
      </div>

      {/* Footer at bottom */}
      <div className="w-full pointer-events-auto">
        <Footer />
      </div>
    </div>
  );
}
